import React, { useState } from 'react';

function ModalDNI({ dni, onSubmit, error }) {
    const [inputDni, setInputDni] = useState(dni);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(inputDni);
    };

    return (
        <>
            <div className="modal fade show" 
                style={{ display: !dni ? 'block' : 'none' }}
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow">
                        <div className="modal-body p-4 text-center">
                            <div className="icon-circle icon-circle-lg bg-light mx-auto mb-4">
                                <i className="bi bi-person-badge icon-lg text-muted"></i>
                            </div>
                            
                            <h5 className="mb-3">Validá tu identidad</h5>
                            <p className="text-muted mb-4">
                                Ingresá tu DNI para acceder a tu cuenta
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        className={`form-control text-center form-control-lg ${error ? 'is-invalid' : ''}`}
                                        id="dniInput"
                                        placeholder="DNI"
                                        value={inputDni}
                                        onChange={(e) => setInputDni(e.target.value)}
                                        maxLength="8"
                                        required
                                    />
                                    <label htmlFor="dniInput">DNI</label>
                                    {error && (
                                        <div className="invalid-feedback text-start">
                                            Acceso incorrecto, asegurate de ingresar tu DNI
                                        </div>
                                    )}
                                </div>
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg w-100"
                                >
                                    Continuar
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ display: !dni ? 'block' : 'none' }}></div>
        </>
    );
}

export default ModalDNI;